import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';

import { authGuard } from '../shared/guards/auth.guard';
import { esRutaDelVisorPublico } from '../shared/utils/public-route.util';

/**
 * Resuelve a dónde llevar una URL sin ruta (la raíz de la aplicación).
 *
 * Normalmente es el área protegida, pero hay un caso en el que redirigir ahí
 * expulsa al usuario de una pantalla pública: MSAL borra el hash de la ventana
 * (`clearHash`) cuando cree estar procesando una respuesta de Azure o cuando su
 * estado de interacción quedó corrupto. Con `withHashLocation()` quedarse sin
 * hash equivale a navegar a la raíz, y desde el visor eso terminaba en el login
 * pese a que el visor no exige sesión.
 *
 * Cuando eso ocurre el router todavía está en la ruta del visor, así que basta
 * con volver a ella en lugar de saltar al área protegida. Ver
 * `specs/spec-036-aislamiento-visor-publico.md`.
 *
 * @returns Ruta destino para la URL vacía
 */
function destinoDeRutaVacia(): string {
  const rutaActual = inject(Router).url;

  return esRutaDelVisorPublico(rutaActual) ? rutaActual : '/app';
}

export const routes: Routes = [
  {
    path: 'app',
    loadChildren: () =>
      import('../protected-area/protected-area.routes').then(
        (m) => m.PROTECTED_ROUTES,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'viewer',
    loadChildren: () =>
      import('../viewer/viewer.routes').then((m) => m.VIEWER_ROUTES),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('../public-area/public-area.routes').then((m) => m.PUBLIC_ROUTES),
  },
  {
    path: '',
    redirectTo: destinoDeRutaVacia,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: destinoDeRutaVacia,
  },
];
